import { render, staticRenderFns } from "./form-signup.vue?vue&type=template&id=108f9371&scoped=true&"
import script from "./form-signup.vue?vue&type=script&lang=js&"
export * from "./form-signup.vue?vue&type=script&lang=js&"
import style0 from "./form-signup.vue?vue&type=style&index=0&id=108f9371&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108f9371",
  null
  
)

export default component.exports